import { locations } from './action_locations';
import moment from "moment-timezone";
import { DATETIME_FORMAT } from "../../timeoff/redux/constants";
import { NOTIFICATION_DATETIME_FORMAT } from "./constants";
import {
    ATTEMPT_LOGIN,
    UPDATE_LOGIN_STATUS,
    LOGIN_ERROR,
    FETCH_NOTIFICATIONS,
    RECEIVED_NOTIFICATIONS,
    ACKNOWLEDGE_NOTIFICATIONS,
    RECEIVED_SUPERVISOR_NOTIFICATIONS,
    RECEIVED_ACKNOWLEDGE
} from './constants';
import {
    CFPost
} from 'util';
import { 
    logout as authLogout,
    isLoggedIn,
    getUser,
    CFAuthGetRef
} from 'auth';

export { agentVerificationLocationFlagAction } from './agentVerificationLocationFlag';

export function loginAction(body) {
    return {
        type: ATTEMPT_LOGIN,
        body: body,
        locations: locations,
        loginApiAction: loginApiAction,
        loginResponseAction: handleLoginResponseAction
    }
}

function loginApiAction(body) {
    return CFPost({
        url: locations.loginUrl,
        body,
        originURL: locations.originUrl,
        loaderName: 'loginAction'
    });
}

function handleLoginResponseAction(response) {
    return async (dispatch) => {
        let credentialsInvalid = typeof response.refreshToken === 'undefined' || 
                                        response.refreshToken === '';
        if (credentialsInvalid) {
            return dispatch({
                type: LOGIN_ERROR,
                error: 'Username or Password invalid. Please try again.'
            })    
        } else {
            const user = getUser();
            const { position, supervisorAgentID } = user;
            const isSupervisor = (position === 2 || position === 3) && (supervisorAgentID === null || supervisorAgentID < 1);

            return dispatch({
                type: UPDATE_LOGIN_STATUS,
                isLoggedIn: isLoggedIn(),
                user,
                isSupervisor
            })
        }
    }
}



export function logoutAction() {
    return function(dispatch) {
        authLogout().then(() => {
            return dispatch({
                type: UPDATE_LOGIN_STATUS,
                isLoggedIn: isLoggedIn()
             })
         })
    }
}

//notification actions
export function fetchNotificationsAction(filters) {
    
    return {
        type: FETCH_NOTIFICATIONS,
        isFetching: true,
        fetchCall: fetchNotifications,
        receivedAction: filters.isSupervisor ? receivedSupervisorNotifications : receivedNotifications,
        data: {
            locations,
            filters
        }
    };
}

function fetchNotifications(filters) {
    return CFAuthGetRef({
        params: {
            isSupervisor: filters.isSupervisor,
            days: 7 //get last 7 days of notifications
        },
		url: process.env.REACT_APP_AP_API_URL + '/Notification/' + filters.userId,
		originURL: process.env.PUBLIC_URL,
        loaderName: ''
	});
}

function receivedNotifications(data) {
    let uiModelData = [];

    if(data && data.length > 0) {
        data.forEach((item, index) => {
            var content = getContentByEnumType(item);            
            uiModelData.push ({
                id: item.id,
                notificationIds: [item.notificationId],
                notificationType: item.notificationType,
                userType: item.userType,
                userId: item.userId,
                isCanceled: item.isCanceled,
                isAcknowledged: item.isAcknowledged,
                acknowledgedDate: item.acknowledgedDate,
                timeoffRequestId: item.timeoffRequestId,
                scheduleStartDate: moment(item.scheduleStartDate).format(DATETIME_FORMAT),
                scheduleEndDate: moment(item.scheduleEndDate).format(DATETIME_FORMAT),
                managementUnitID: item.managementUnitID,
                managementUnitName: item.managementUnitName,
                dateCreated: moment(item.dateCreated).format(NOTIFICATION_DATETIME_FORMAT),
                dateUpdated: item.dateUpdated,
                createdBy: item.createdBy,
                updatedBy: item.updatedBy,
                text: content.text,
                description: content.description,
                link: content.link,
                route: content.route,
                isSupervisor: false
            });
		});
	}

    let sortedNotifications = uiModelData.sort(function(a, b) {
        let date1 = new Date(a.dateCreated);
        let date2 = new Date(b.dateCreated)

        if (date1 > date2) return -1;
        if (date1 < date2) return 1;
        return 0;
    })

    var hasNewNotifications = uiModelData.filter((e) => e.isAcknowledged === false).length > 0 ? true : false;
    
    return {
		type: RECEIVED_NOTIFICATIONS,
        notifications: sortedNotifications,
        isFetching: false,
        hasNewNotifications: hasNewNotifications        
    };
}

function receivedSupervisorNotifications(data) {
    let uiModelData = [];
    let groupByItems = data.groupBy('isAcknowledged')
    let groupByUnAck = groupByItems.false !== undefined ? groupByItems.false.groupBy('managementUnitName'): {}
    let groupByAck = groupByItems.true !== undefined ? groupByItems.true.groupBy('managementUnitName'): {}
    
    Object.keys(groupByUnAck).forEach(function(keyName, keyIndex) {
        var element = groupByUnAck[keyName];
        uiModelData.push ({
            text: "Time Off",
            description: `(${element.length}) Pending requests for review`,
            link: keyName,
            isAcknowledged: false,
            notificationIds: element.map(notification => {return notification.id}),
            isSupervisor: true,
            managementUnitID: element[0].managementUnitID
        });
    })

    Object.keys(groupByAck).forEach(function(keyName, keyIndex) {
        var element = groupByAck[keyName];
        uiModelData.push ({
            text: "Time Off",
            description: `(${element.length}) Pending requests for review`,
            link: keyName,
            isAcknowledged: true,
            notificationIds: element.map(notification => {return notification.id}),
            isSupervisor: true,
            managementUnitID: element[0].managementUnitID
        });
    })

    var hasNewNotifications =  Object.keys(groupByUnAck).length > 0  ? true : false;
    
    return {
		type: RECEIVED_SUPERVISOR_NOTIFICATIONS,
        notifications: uiModelData,
        isFetching: false,
        hasNewNotifications: hasNewNotifications
    };
}

function getContentByEnumType(item) {
    let result = {
        text: "",
        description: "",
        link: ""
    };
    
    let notificationTypeId = item.notificationType;
    
    //set agent date range link
    let scheduleStartDate = moment(item.scheduleStartDate).format(NOTIFICATION_DATETIME_FORMAT);
    let scheduleEndDate = moment(item.scheduleEndDate).format(NOTIFICATION_DATETIME_FORMAT);

    result.link = scheduleStartDate !== scheduleEndDate ? scheduleStartDate + " - " + scheduleEndDate : scheduleStartDate

    if(notificationTypeId === 0) { 
        result.text = "Time Off";
        result.description = "";
        result.route="TimeOff";
    }
    else if (notificationTypeId === 1) {
        result.text = "Time Off";
        result.description = "Request Approved for";
        result.route="TimeOff";
    }
    else if (notificationTypeId === 2 ){
        result.text = "Time Off";
        result.description = "Request Denied for";
        result.route="TimeOff";
    }
    else if (notificationTypeId === 3) {
        result.text = "Time Off";
        result.description = "Request Canceled for";
        result.route="TimeOff";
    }
    else if (notificationTypeId === 4) {
        result.text = "Schedule";
        result.description = "New Schedule dates are available";
        result.route="Schedules";
    }
    else if (notificationTypeId === 5) {
        result.text = "Schedule";
        result.description = "Schedule Updated for";
        result.route="Schedules";
    }
    else if( notificationTypeId === 6) {
        result.text = "Hours";
        result.description = "Hours Updated for";
        result.route="Schedules";
    }
    return result;
}

//TODO: move this to a util file and re-use in weekly schedule container instead of duplicating code
Array.prototype.groupBy = function(prop) {
    return this.reduce(function(groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
    }, {});
};

export function acknowledgeNotificationAction(filters) {
    return {
        type: ACKNOWLEDGE_NOTIFICATIONS,
        fetchCall: fetchAcknowledge,
        receivedAction: receivedAcknowledge,
        data: {
            locations,
            filters
        }
    };
}

function fetchAcknowledge(filters) {
    let requestParam = {};
    if(filters.notificationIds !== null) {
        requestParam = {
            notificationIds:filters.notificationIds.toString(),
            isSupervisor:filters.isSupervisor,
            userId:filters.userId
        };
    }
    else {
        requestParam = {
            isSupervisor:filters.isSupervisor,
            userId:filters.userId
        };
    }

    return CFAuthGetRef({
        params: requestParam,
		url: process.env.REACT_APP_AP_API_URL + '/Notification/Acknowledge',
		originURL: process.env.PUBLIC_URL,
        loaderName: ''
	});
}

function receivedAcknowledge(res){    
    return{
        type: RECEIVED_ACKNOWLEDGE,
        notificationId: res.notificationIds !== null ? JSON.parse("[" + res.notificationIds + "]") : null,
    }
}

export function isBellRedAction(anyUnAckNotifications){
    return {
        type: 'BELL_CHECK',
		anyUnAckNotifications: anyUnAckNotifications
    };
}

export function triggerClickSwitch(clickSwitch){
    return {
        type: 'CLICK_SWITCH',
        clickSwitch: clickSwitch
    };
}

export function setDevice(width){
    let isNotDesktop = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) ? false : true;
    
    //tablet
    let isTablet = /*width > 767 &&*/ width < 1025 ? true : false;
    
    return {
        type: 'TABLET',
        isTablet: isTablet,
        isNotDesktop: isNotDesktop
    };
}

export function setDeviceOrientation(orientation){
    let isPortraitOrientation = orientation === 90 ? false : true;
    return {
        type: 'IS_PORTRAIT_ORIENTATION',
        isPortraitOrientation: isPortraitOrientation
    };
}

export function setSignalrConnectionAction() {
    return {
        type: 'SET_SIGNALR_CONNECTION'
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case UPDATE_LOGIN_STATUS:
            return {
                ...state,
                loginError: '',
                isLoggedIn: action.isLoggedIn,
                user: action.user,
                isSupervisor: action.isSupervisor
            }
        case LOGIN_ERROR:
            return {
                ...state,
                loginError: action.error,
                isLoggedIn: false
            }
        case FETCH_NOTIFICATIONS:
        return {
            ...state,
            isFetching: true
        }
        case RECEIVED_NOTIFICATIONS:
        return {
            ...state,
            notifications: action.notifications,
            isFetching: action.isFetching,
            hasNewNotifications: action.hasNewNotifications
        }
        case RECEIVED_SUPERVISOR_NOTIFICATIONS:
        return {
            ...state,
            notifications: action.notifications,
            isFetching: action.isFetching,
            hasNewNotifications: action.hasNewNotifications
        }
        case RECEIVED_ACKNOWLEDGE:
            return {
                ...state,
                acknowledCompleted: action.notificationId                            
            }

        case 'CLICK_SWITCH':
            return {
                ...state,
                clickSwitch: Math.random()
            }
        case 'BELL_CHECK':
        return {
            ...state,
            acknowledCompleted: 0,
            anyUnAckNotifications: action.anyUnAckNotifications
        }
        case 'TABLET':
        return {
            ...state,
            isTablet: action.isTablet,
            isNotDesktop: action.isNotDesktop
        }
        case 'IS_PORTRAIT_ORIENTATION':
        return {
            ...state,
            isPortraitOrientation: action.isPortraitOrientation
        }
        case 'SET_SIGNALR_CONNECTION':
        return {
            ...state
        }
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/features/common/redux/actions.js